import { useNavigate } from '@tanstack/react-router';
import { ProgramCreateSuccessPage as ProgramCreateSuccessPageComponent } from './ProgramCreateSuccessPage.component';

export default function ProgramCreateSuccessPage() {
  const navigate = useNavigate();

  return (
    <ProgramCreateSuccessPageComponent
      onCreateJob={() => {
        void navigate({ to: '/vagas/nova' });
      }}
      onBackToPrograms={() => {
        void navigate({ to: '/programas' });
      }}
    />
  );
}
